import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

const Header = ({ siteTitle }) => (
  <header>
    <h1 className="font-serif text-4xl mt-2 sm:mt-6 sm:text-6xl">
      <Link to="/">{siteTitle}</Link>
    </h1>
    <h2 className="font-sans font-light text-xl sm:text-2xl">
      Conductor, Musical Supervisor and Musicologist
    </h2>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
